const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;

export function generateUrlSearchParams(lat: number, lng: number) {
  const searchParams = new URLSearchParams();

  searchParams.append('center', `${lat},${lng}`);
  searchParams.append('zoom', '16');
  searchParams.append('size', '5000x300');
  searchParams.append('scale', '2');
  searchParams.append('markers', `color:red|${lat},${lng}`);
  searchParams.append('key', googleMapsKey);

  return searchParams.toString();
}
